import { render, staticRenderFns } from "./CreateSubCategoryModal.vue?vue&type=template&id=60b0c8d6&scoped=true"
import script from "./CreateSubCategoryModal.vue?vue&type=script&lang=js"
export * from "./CreateSubCategoryModal.vue?vue&type=script&lang=js"
import style0 from "./CreateSubCategoryModal.vue?vue&type=style&index=0&id=60b0c8d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b0c8d6",
  null
  
)

export default component.exports